export default __webpack_public_path__ + "static/media/github.a2a9d707.jpg";